//App
import { UserDto } from "../app/model/api/types/dto/userDto";

export class UserViewModel {
  id?: string | null;
  organizationId?: string | null;
  firstName: string | null;
  lastName: string | null;
  userName: string | null;
  roleId: Array<string> | null;
  email: string | null;
  phoneNumber: string | null;
  isActive: boolean | null;
  createdDateUtc?: string | null;

  constructor(
    id: string | null,
    organizationId: string | null,
    firstName: string | null,
    lastName: string | null,
    roleId: Array<string> | null,
    userName: string | null,
    email: string | null,
    phoneNumber: string | null,
    isActive: boolean | null,
    createdDateUtc: string | null
  ) {
    this.id = id;
    this.organizationId = organizationId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.userName = userName;
    this.email = email;
    this.roleId = roleId;
    this.phoneNumber = phoneNumber;
    this.isActive = isActive;
    this.createdDateUtc = createdDateUtc;
  }

  toDto(): UserDto {
    return {
      id: this.id,
      userId: this.id,
      organizationId: this.organizationId,
      roleId:
        this.roleId !== null && this.roleId?.length > 0 ? this.roleId[0] : null,
      isActive: this.isActive,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      userName: this.userName,
      phoneNumber: this.phoneNumber,
      createdDateUtc: this.createdDateUtc,
    };
  }

  mapFromDto(dto: UserDto): void {
    this.id = dto.id;
    this.organizationId = dto.organizationId;
    this.isActive = dto.isActive || true;
    this.firstName = dto.firstName;
    this.lastName = dto.lastName;
    dto.roleId !== null ? this.roleId?.push(dto.roleId) : (this.roleId = null);
    this.userName = dto.userName;
    this.email = dto.email ?? null;
    this.phoneNumber = dto.phoneNumber;
    this.createdDateUtc = dto.createdDateUtc;
  }
}
